import { useEffect } from 'react';

import { useMutationCallbacks } from '@woovi/relay';

import type { ChargeViewMutation } from './mutations/__generated__/ChargeViewMutation.graphql.ts';
import { ChargeView } from './mutations/ChargeViewMutation.tsx';

export const useChargeView = (chargeId: string) => {
  const [chargeView] = useMutationCallbacks<ChargeViewMutation>({
    name: 'ChargeView',
    mutation: ChargeView,
    shouldShowSnackbar: false,
  });

  useEffect(() => {
    if (!chargeId) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);

    const medium = searchParams.get('utm_medium');

    if (medium !== 'email' && medium !== 'sms') {
      return;
    }

    const input = {
      id: chargeId,
      medium,
    };

    const config = {
      variables: {
        input,
      },
    };

    chargeView(config);

    return;
  }, []);
};
